import { SYS_SPACE_FIXED_200 } from '@oneaudi/unified-web-common';
import styled from 'styled-components';

export const SelectionStepBlock = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${SYS_SPACE_FIXED_200};
`;
